<top-banner *ngIf="validBrowser" class="notice" (onClose)="updateBannerClosingDate()" closable>
    <ng-container i18n>You are currently using an unsupported or an old version of your browser. For best performance please update to the latest
      version of one of these browsers: Google Chrome, Safari, Mozilla Firefox, Microsoft Edge, Opera.
    </ng-container>
</top-banner>
  
  
